var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"icon-secondary"},on:{"click":function($event){return _vm.$emit("click")}}},[_c('font-awesome-icon',{attrs:{"icon":"fa-regular fa-cog"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }